<template>
    <div :id="id" :class="['btn-wrapper', id]" v-show="show">
        <div class="btn flex-y-center" @mouseenter="Hover($event, true)" @mouseleave="Hover($event, false)">
            <img :src="source" :alt="`Navigate ${direction}`" :title="`Navigate ${direction}`" width="30" height="55"/>
        </div>
    </div>
</template>

<script>
import { ScrollAction } from "@/assets/JS/Master.js";
import { CONFIG } from "@/assets/JS/Config.js";
import $ from "jquery";

export default {
    name: "TimelineControl",
    props: {
        id: String,
        direction: String,
        show: Boolean
    },
    data: () => ({ source: "" }),
    beforeMount: function() {
        const source = this.direction === "Left" ? "TimelineArrowLeft.png" : "TimelineArrowRight.png";
        this.source = require(`@/assets/Images/${source}`);
    },
    methods: {
        Hover: function(target, over) {
            this.$emit("navigate", {
                direction: this.direction,
                hovering: over
            });

            // Calculates the top position of the timeline so the arrow position updates dependent on scroll location
            const timelinePosition = $("#timeline").position();
            const $arrow = $(`#${this.id}`).find("img");
            const top = over ? (target.pageY - timelinePosition.top) : 0
            $arrow.css("top", `${top}px`);

        }
    },
    mounted: function() {

        // Scroll Action enables the navigation arrows to be fixed to the screen
        if (CONFIG.timeline.navigation.useScrollAction) {
            const instance = `#${this.id}`;
            const $arrow = $(instance).find("img");
            new ScrollAction(
                $arrow,
                600,
                {
                    position: this.direction,
                    padding: this.direction === "Left" ? 100 : 30
                }
            );

            // Offset control so it doesn't get buried by the Y Bar
            if (this.direction === "Left") {
                $arrow.css("left", "70px");
            }

        }

    },
    emits: [ "navigate" ]
};
</script>